<template>
  <v-card flat class="mb-2 pa-2  lighten-5">
    <v-card-text>
      <v-row>
        <v-col xs="12">
          <v-progress-linear indeterminate color="primary" v-if="processing"></v-progress-linear>
          <v-subheader style="font-size: 16px!important;">Servicios Móviles (% Bajas a 180 días)</v-subheader>
          <v-autocomplete
            label="Tipo producto"
            v-model="tipoProductoSelected"
            :items="tipoProductoOptions"
            item-text="label"
            item-value="value"
            prepend-inner-icon="scatter_plot"
            append-icon="keyboard_arrow_down"
            class="pa-3"
          ></v-autocomplete>

          <div ref="amchart" style="height: 45vh;"></div>

          <v-alert
            dense
            type="warning"
            text
            v-show="!processing && isChartEmpty"
          >No existe información para esta gráfica</v-alert>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import apiDashboard from "@/api/dashboards";
import { mapActions } from "vuex";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themesAnimated from "@amcharts/amcharts4/themes/material";
import { store } from "@/store";
import moment from "moment";

am4core.useTheme(am4themesAnimated);

export default {
  props: ["fechaFin"],
  data() {
    return {
      processing: false,
      chartData: [],
      chart: null,
      tipoProductoSelected: null,
      tipoProductoOptions: [
        { label: "Todos", value: "SERVICIOS MOVILES" },
        { label: "Banda Ancha", value: "BANDA ANCHA" },
        { label: "Control", value: "CONTROL" },
        { label: "Flota", value: "FLOTA" },
        { label: "PostPago", value: "POSTPAGO" }
      ]
    };
  },
  computed: {
    isChartEmpty() {
      return this.chartData.length === 0;
    }
  },
  methods: {
    ...mapActions(["setError", "setErrorMessage", "setMessage"]),
    generateChart(dataParam) {
      if (this.chart) {
        this.chart.dispose();
      }

      try {
        let chart = am4core.create(this.$refs.amchart, am4charts.XYChart);
        chart.colors.step = 7;
        chart.legend = new am4charts.Legend();
        chart.exporting.menu = new am4core.ExportMenu();
        chart.numberFormatter.numberFormat = "$#,###.##";

        let data = [];
        var periodo = [];
        dataParam.forEach(function(row) {
          if (periodo.indexOf(row.Fecha) === -1) {
            periodo.push(moment(row.Fecha).format("YYYY-MM"));
          }
        });

        periodo.forEach(function(d) {
          let rows = dataParam.filter(
            f => moment(f.Fecha).format("YYYY-MM") === d
          );
          let newRow = {
            Periodo: d,
            Canal: 0,
            CAC: 0,
            Asociado: 0
          };
          let tasaAsociado = 0;
          let tasaCanal = 0;
          let tasaCAC = 0;

          rows.forEach(function(c) {
            if (c) {
              if (c.CodAsociado === "DAC") {
                tasaCanal = c.Tasa;
              } else if (c.CodAsociado === "CAC") {
                tasaCAC = c.Tasa;
              } else {
                tasaAsociado = c.Tasa;
              }
            }
          });
          newRow["Canal"] = (tasaCanal * 100).toFixed(2);
          newRow["CAC"] = (tasaCAC * 100).toFixed(2);
          newRow["Asociado"] = (tasaAsociado * 100).toFixed(2);
          data.push(newRow);
        });

        chart.data = data;

        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "Periodo";
        categoryAxis.title.text = "Periodo";
        categoryAxis.renderer.minGridDistance = 20;
        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 35;
        valueAxis.renderer.labels.template.adapter.add("text", function(text) {
          return text + "%";
        });

        let series = chart.series.push(new am4charts.ColumnSeries());
        series.dataFields.categoryX = "Periodo";
        series.dataFields.valueY = "Canal";
        series.name = store.getters.user.canal;
        series.stacked = true;
        series.columns.template.fill = am4core.color("#F4D03F");
        series.columns.template.stroke = am4core.color("#F4D03F");
        series.columns.template.width = am4core.percent(80);

        series.columns.template.tooltipText = "{name}: [bold]{valueY}%[/]";
        series.stacked = true;

        let lineSeries = chart.series.push(new am4charts.LineSeries());
        lineSeries.dataFields.categoryX = "Periodo";
        lineSeries.dataFields.valueY = "Asociado";
        lineSeries.name = store.getters.user.nombre;
        lineSeries.strokeWidth = 3;
        var circleBullet = lineSeries.bullets.push(
          new am4charts.CircleBullet()
        );
        circleBullet.circle.stroke = am4core.color("#fff");
        circleBullet.tooltipText = "{name}: [bold]{valueY}%[/]";

        let lineSeriesCAC = chart.series.push(new am4charts.LineSeries());
        lineSeriesCAC.dataFields.categoryX = "Periodo";
        lineSeriesCAC.dataFields.valueY = "CAC";
        lineSeriesCAC.name = "Mejores Prácticas";
        lineSeriesCAC.strokeWidth = 3;
        var circleBullletCAC = lineSeriesCAC.bullets.push(
          new am4charts.CircleBullet()
        );
        circleBullletCAC.circle.stroke = am4core.color("#fff");
        circleBullletCAC.tooltipText = "{name}: [bold]{valueY}%[/]";

        this.chart = chart;
      } catch (e) {
        // empty
      }
    },
    refresh() {
      if (this.fechaFin && this.tipoProductoSelected) {
        this.processing = true;
        let param = {
          FechaFin: this.fechaFin,
          TipoProducto: this.tipoProductoSelected,
          CodigoAsociado: store.getters.user.asociado.codigo,
          Chart: "ServicioMovil"
        };

        apiDashboard
          .getChartCalidadVenta(param)
          .then(response => {
            this.chartData = response.data;
            this.generateChart(this.chartData);
            this.processing = false;
          })
          .catch(error => {
            this.setError(error);
            this.processing = false;
          });
      }
    }
  },
  watch: {
    fechaFin: function() {
      this.refresh();
    },
    tipoProductoSelected: function() {
      this.refresh();
    }
  },
  mounted() {
    this.tipoProductoSelected = this.tipoProductoOptions[0].value;
    this.refresh();
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  }
};
</script>

<style scope>
.v-alert.v-sheet.theme--dark.v-alert--dense.warning {
  margin-bottom: 0;
}
</style>